<template>
  <transition name="list">
     <span class="lee-tag"
      :style="'color:'+cor(item.color)+';background:'+bg(item.color)+';border:solid 1px '+bor(item.color)+';'">{{item.t}}<i
    v-if="taggroup.closeable" @click="del(item)"></i></span>
  </transition>
</template>
<script>
export default {
    name: 'LeeTag',
    data() {
        return {}
    },
    inject: ['taggroup'],
    mounted() {

    },
    methods: {
        del(item) {
            let xh = this.taggroup.tags.indexOf(item)
            this.taggroup.tags.splice(xh, 1)
        },
        tonum(str) {
            switch (str) {
                case 'a':
                case 'A':
                    str = 10
                    break;
                case 'b':
                case 'B':
                    str = 11
                    break;
                case 'c':
                case 'C':
                    str = 12
                    break;
                case 'd':
                case 'D':
                    str = 13
                    break;
                case 'e':
                case 'E':
                    str = 14
                    break;
                case 'f':
                case 'F':
                    str = 15
                    break;
            }
            return str
        },
        torgb(color) {
            var color = color.split('#')[1]
            var r = color.slice(0, 2)
            var r1 = r.slice(0, 1)
            var r2 = r.slice(1, 2)
            var g = color.slice(2, 4)
            var g1 = g.slice(0, 1)
            var g2 = g.slice(1, 2)
            var b = color.slice(4, 6)
            var b1 = b.slice(0, 1)
            var b2 = b.slice(1, 2)
            var R = Number(this.tonum(r1) * 16) + Number(this.tonum(r2))
            var G = Number(this.tonum(g1) * 16) + Number(this.tonum(g2))
            var B = Number(this.tonum(b1) * 16) + Number(this.tonum(b2))
            return {R: R, G: G, B: B}
        },
        bg(color) {
            if (color == undefined) {
                color = "#46bd87"
            }
            var R = this.torgb(color).R
            var G = this.torgb(color).G
            var B = this.torgb(color).B
            return 'rgba(' + R + ',' + G + ',' + B + ',.1)'


        },
        bor(color) {
            if (color == undefined) {
                color = "#46bd87"
            }
            var R = this.torgb(color).R
            var G = this.torgb(color).G
            var B = this.torgb(color).B
            return 'rgba(' + R + ',' + G + ',' + B + ',.2)'


        },
        cor(color) {
            if (color == undefined) {
                color = "#46bd87"
            }
            var R = this.torgb(color).R
            var G = this.torgb(color).G
            var B = this.torgb(color).B
            return 'rgb(' + R + ',' + G + ',' + B + ')'


        }

    },
    props: {
        item: {
            type: Object,
            default() {
                return {}
            }
        }
    }
};
</script>
<style scoped>
.list-leave-to,
.list-enter {
  opacity: 0;
  transform: translateY(32px)
}

.lee-tag {
  box-sizing: border-box;
  height: 32px;
  line-height: 32px;
  font-size: 12px;
  display: flex;
  padding: 0 10px;
  margin-left: 10px;
  margin-bottom: 10px;
  white-space: nowrap;
  border-radius: 4px;
  align-items: center;
  transition: all .5s;
}

.lee-tag i {
  margin-right: -8px;
  cursor: pointer;
  width: 16px;
  height: 16px;
  line-height: 16px;
  position: relative;
  transform: rotate(45deg);
}

.lee-tag i:hover {
  border-radius: 100%;
  background: currentColor;
}

.lee-tag i:before {
  content: "";
  width: 1px;
  height: 60%;
  position: absolute;
  background: currentColor;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.lee-tag i:after {
  content: "";
  height: 1px;
  width: 60%;
  position: absolute;
  background: currentColor;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.lee-tag i:hover:before {
  background: #fff
}

.lee-tag i:hover:after {
  background: #fff
}

</style>



// WEBPACK FOOTER //
// node_modules/leevueplugin/src/LeeTag.vue